import { createContext } from "react";
import { HouseContextDetails } from "./types";

export const HouseCompetitionData = createContext<HouseContextDetails>({
  competitionId: 0,
  prizeId: 0,
  basePriceWithoutCurrency: "0",
  currencySymbol: "£",
  prizeTitle: "",
  detailsText: "",
  cashAlternativePopupText: "",
  prizeSubtitle: "",
  cashAlternativeText: "",
  activePriceWithoutCurrency: "0",
  amenitiesPopupText: "",
  amentiesImages: [],
  isPrizeAvailable: false,
  discountPercentage: 0,
  overrideDiscountValue: 0,
  basePriceWithCurrency: "£0",
  socialReviews: "",
  prizeTags: [],
  shouldShowSubscriptionDrawer: false,
  hideCashAlternative: false,
  isHousePrizeOnly: false,
});
